/* eslint-disable camelcase */
import {
    de,
    enUS,
    es,
    fr,
    hu,
    it,
    ja,
    ko,
    nl,
    pl,
    pt,
    ptBR,
    ru,
    sv,
    th,
    tr,
    zhCN,
    zhTW,
} from 'date-fns/locale';

export default Object.freeze({
    de,
    en: enUS,
    es,
    fr,
    hu,
    it,
    ja,
    kr: ko,
    nl,
    pl,
    pt_BR: ptBR,
    pt_PT: pt,
    ru,
    sv,
    th,
    tr,
    zh_TW: zhTW,
    zh: zhCN,
});
